<template>
	<div>
		<v-select
				v-model="selectedItem"
				:items="availableItems"
				item-text="name"
				item-value="id"
				:label="selectorLabel"
				outlined
				@change="addItem"
		></v-select>
		<v-list dense>
			<v-list-item v-for="(itemId, index) in sortableList" :key="itemId">
				<v-list-item-content>
					{{ findItem(itemId).name }}
				</v-list-item-content>
				<v-list-item-action>
					<div
							style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;"
							v-if="index >= lockedRows">
						<v-btn @click="moveElement(index, -1)" icon :disabled="index <= lockedRows">
							<v-icon color="gray">mdi-arrow-up</v-icon>
						</v-btn>
						<v-btn @click="moveElement(index, 1)" icon
									 :disabled="index === sortableList.length - 1">
							<v-icon color="gray">mdi-arrow-down</v-icon>
						</v-btn>
						<v-btn @click="removeItem(index)" icon>
							<v-icon color="red">mdi-trash-can-outline</v-icon>
						</v-btn>
					</div>
				</v-list-item-action>
			</v-list-item>
		</v-list>
	</div>
</template>

<script>

export default {
	props: {
		items: {
			type: Array,
			required: true,
		},
		value: {
			required: true,
			validator: v => true
		},
		selectorLabel: {
			type: String,
			default: 'Select an item',
		},
		lockedRows: {
			type: Number,
			default: 0,
		}
	},
	data() {
		return {
			selectedItem: null,
			dragOptions: {
				animation: 150,
			},
			sortableList: this.value,
		};
	},
	computed: {
		availableItems: {
			get() {
				if(!this.sortableList) {
					return this.items;
				}
				return this.items.filter(item => !this.sortableList.includes(item.id));
			},
		},
	},
	methods: {
		addItem() {
			if(this.selectedItem) {
				this.sortableList.push(this.selectedItem);
				this.selectedItem = null;
				this.$emit('input', this.sortableList);
			}
		},
		removeItem(index) {
			this.sortableList.splice(index, 1);
			this.$emit('input', this.sortableList);
		},
		findItem(id) {
			return this.items.find(item => item.id === id);
		},
		moveElement(index, direction) {
			const newIndex = index + direction;
			const element = this.sortableList[index];
			this.sortableList.splice(index, 1);
			this.sortableList.splice(newIndex, 0, element);
			this.$emit('input', this.sortableList);
		},
	},
};
</script>
